export default function BasketFixedStorage(
    localStorageService,
    Log,
    $timeout,
    $q,
    ENV
) {
    const storageKey = "basket-fixed";

    /**
     * interface with localStorageService
     */
    const StorageFacade = {
        get: () => {
            return localStorageService.get(storageKey);
        },

        set: (storageObj) => {
            localStorageService.set(storageKey, storageObj);
        },

        removeAll: () => {
            localStorageService.remove(storageKey);
        },
    };

    const storageModel = {
        bookingId: null, // int
        periods: [], // array
        activity: null, // activityModel (houseCategory)
        location: null, // locationModel (houseType)
        searchPeriodsUrl: null,
        // storageVersion: null,
    };

    var fn = this;

    /**
     * construct
     */
    fn.init = () => {
        let storage = StorageFacade.get();

        if (!storage) {
            StorageFacade.set(storageModel);

            // fn.setStorageVersion(ENV.storageVersion);

            return storageModel;
        }

        /**
         * Check storage version
         * By raising the storageVersion (__env.js) we clear all localstorage for the client
         */
        // return maybeUpgrageStorageVersion(
        //     storage,
        //     storageModel,
        //     ENV.storageVersion
        // );
        // console.log(fn.getStorageVersion() + "!==" + ENV.storageVersion);

        return storage;
    };

    /*******************************************************
     * Getters / Setters
     */

    /**
     * Storage Version
     */
    fn.getStorageVersion = () => {
        let storage = StorageFacade.get();

        return storage ? storage.storageVersion : null;
    };

    fn.setStorageVersion = (storageVersion) => {
        let storage = StorageFacade.get();

        storage.storageVersion = storageVersion;

        StorageFacade.set(storage);
    };

    /**
     * Booking ID
     */
    fn.getBookingIdStorage = () => {
        let storage = StorageFacade.get();

        return storage ? storage.bookingId : null;
    };

    fn.setBookingIdStorage = (bookingId) => {
        let storage = StorageFacade.get();

        storage.bookingId = bookingId;

        StorageFacade.set(storage);
    };

    fn.deleteBookingId = () => {
        let storage = StorageFacade.get();

        storage.bookingId = null;

        StorageFacade.set(storage);
    };

    /**
     * Current bookings
     */
    fn.getBookingsStorage = () => {
        let storage = StorageFacade.get();

        return storage ? storage.periods : [];
    };

    fn.setBookingsStorage = (periods) => {
        let storage = StorageFacade.get();

        const updatedPeriods = periods // if new periods
            ? periods // use new Periods
            : []; // else set empty

        storage.periods = updatedPeriods;

        StorageFacade.set(storage);
    };

    /**
     * Current Activity
     */

    fn.getBookingActivity = () => {
        let storage = StorageFacade.get();

        return storage.activity;
    };

    fn.setBookingActivity = (activity) => {
        let storage = StorageFacade.get();

        storage.activity = activity;
        StorageFacade.set(storage);
    };

    /**
     * Current Location
     */

    fn.getBookingLocation = (location) => {
        let storage = StorageFacade.get();

        return storage.location;
    };
    fn.setBookingLocation = (location) => {
        let storage = StorageFacade.get();

        storage.location = location;
        StorageFacade.set(storage);
    };

    /**
     * Last searchPeriodsUrl
     */

    fn.getSearchPeriodsUrl = () => {
        let storage = StorageFacade.get();

        return decodeURI(storage.searchPeriodsUrl);
    };
    fn.setSearchPeriodsUrl = (url) => {
        let storage = StorageFacade.get();

        storage.searchPeriodsUrl = url;

        StorageFacade.set(storage);
    };

    /**
     * get Bookings
     */
    fn.getBookings = () => {
        let storage = StorageFacade.get();
        return storage.bookings;
    };

    fn.resetBasketFixedStorage = function () {
        Log.string("BASKET", "clear storage");
        StorageFacade.removeAll();
    };

    return fn;
}
